import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Routes from "../../Constants/Routes";
import { Link } from "react-router-dom";
import Images from "../../Constants/Images";
function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <React.Fragment>
      <div className="footer">
        <Container>
          <Row className="g-3 row-cols-xxl-4 row-cols-xl-4 row-cols-lg-4 row-cols-md-2 row-cols-1">
            <Col>
              <div className="company-info">
                <h6>Powered By</h6>
                <ul>
                  <li>
                    <img
                      src={Images.bottomLogo}
                      alt="Logo"
                    />
                  </li>
                  <li>
                    <i class='bx bxs-location-plus'></i>
                    <p>  Nazafgarh, New Delhi - 110043</p>
                  </li>
                  <li>
                    <i class='bx bxs-phone-call' ></i>
                    <a href="tel:+91-8799701700">+91-8799701700</a>
                  </li>
                  <li>
                    <i class='bx bxs-envelope' ></i>
                    <a href="mailto:care@sabkavadiya.com" className="text-lowercase">
                      care@sabkavaidya.com
                    </a>
                  </li>
                  <li>
                    <a href="https://www.facebook.com/sabkavaidya1" target="_blank">
                      <i class='bx bxl-facebook-circle'></i>
                    </a>
                    <a href="https://www.instagram.com/sabkavaidya/" target="_blank">
                      <i class='bx bxl-instagram-alt' ></i>
                    </a>
                    <a href="https://www.linkedin.com/company/vaidyas-tattva/" target="_blank">
                      <i class='bx bxl-linkedin-square' ></i>
                    </a>
                  </li>
                </ul>
              </div>
            </Col>
            <Col>
              <h6>Quick links</h6>
              <div className="footer-links">
                <ul>
                  <li>
                    <Link to={Routes.publicRoutes.OurCenters}>our centers</Link>
                  </li>
                  <li>
                    <Link to={Routes.publicRoutes.OurExperts}>our expert</Link>
                  </li>
                  <li>
                    <Link to={Routes.publicRoutes.AboutUs}>About Sabka vadiya</Link>
                  </li>
                  <li>
                    <Link to={Routes.publicRoutes.ContentIntegrity}>Content Integrity</Link>
                  </li>
                </ul>
              </div>
            </Col>
            <Col>
              <h6>Our Blogs</h6>
              <div className="footer-links">
                <ul>
                  <li>
                    <Link to={Routes.publicRoutes.Blogs.Herbs.HerbsFood}>Herbs/Food</Link>
                  </li>
                  <li>
                    <Link to={Routes.publicRoutes.Blogs.Medicine.MedicineBlog}>Blogs/Videos</Link>
                  </li>
                  <li>
                    <Link to={Routes.publicRoutes.Diseases}>Disease</Link>
                  </li>
                  <li>
                    <Link to={Routes.publicRoutes.Blogs.Video.VideoBlog}>video blog</Link>
                  </li>
                </ul>
              </div>
            </Col>

            <Col>
              <h6>Policies</h6>
              <div className="footer-links">
                <ul>
                  <li>
                    <Link to={Routes.publicRoutes.TermsCondition}>
                      Terms and Condition
                    </Link>
                  </li>
                  <li>
                    <Link to={Routes.publicRoutes.ShippingPolicy}>
                      Shipping Policy
                    </Link>
                  </li>
                  <li>
                    <Link to={Routes.publicRoutes.ReturnPolicy}>
                      Return Policy
                    </Link>
                  </li>
                  <li>
                    <Link to={Routes.publicRoutes.PrivacyPolicy}>
                      Privacy Policy
                    </Link>
                  </li>
                  <li>
                    <Link to={Routes.publicRoutes.EditorialPolicy}>
                      Editorial Policy
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
          <hr />
          <div className="copy-right">
            <Row className="g-1 row-cols-xxl-2 row-cols-xl-2 row-cols-lg-2 row-cols-md-2 row-cols-1 align-items-center">
              <Col>
                <p>&copy; {currentYear} Vaidyas Tattva Private Limited.</p>
              </Col>
              <Col className="text-lg-end">
                <a href="https://sabkavaidya.com/sitemap.xml" className="text-white">Site Map</a>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Footer;
